<div class="offer_creator_item">

    @if(isMine) {

        <div class="row marges ligne_form" style="margin-top: 12px;">
            <div class="col_12">
                <div class="form-group">
                    <span class="message-help"><mat-icon>info</mat-icon>{{ 'offerCreator.data.information.value' | translate }}</span>
                </div>
            </div>
        </div>
    }

    @if(hasAccessIntlView && locales.length) {

        <div class="row marges ligne_form" style="margin-top: 12px;">
            <div class="col_12 col_md_4">
                <div class="form-group choice_language">
                    <label><strong>{{ 'offer.read.choiceLanguage.value' | translate }} :</strong></label>
                    <mat-select [(ngModel)]="locale" class="no_label">
                        @for(locale of locales; track locale) {
                            <mat-option [value]="locale.id">
                                {{ locale.label | translate }}
                            </mat-option>
                        }
                    </mat-select>
                </div>
            </div>
        </div>
    }

    <form [formGroup]="form" (ngSubmit)="formService.submit()">

        <div class="title_offer">

            <div class="row marges">

                <!-- Logo -->

                <div class="col_content y_items_center">
                    <img [src]="item.logo ? ( item.logo | fileSource | async) : defaultVisualUrl" [alt]="item.name">
                </div>

                <!-- Nom -->

                <div class="col y_items_center">
                    <p class="title">{{ item.name }}</p>
                </div>

                <div class="col y_items_center x_end">
                    @if(!isDisplayedPhone) {
                        <button class="btn_cta btn_little btn_green_lines" type="button" (click)="displayPhone()">
                            <span class="icon-tywin-phone">{{'offerCreator.contact.value' | translate}}</span>
                        </button>
                    } @else {
                        <button class="btn_cta btn_little btn_degrade" type="button">
                            <span>{{phoneNumber}}</span>
                        </button>
                    }
                </div>
            </div>
        </div>

        <!-- Visuels -->

        @if(item.pictures.length) {

            <div class="row ligne_form offer_pictures">

                <!-- Visuel principal -->

                <div [ngClass]="{ 'col_6' : item.pictures.length > 1, 'col_12' : item.pictures.length <= 1 }" class="col_md_6 col_left">
                    <img [src]="item | offerCreatorPictureSource: item.pictures[0] : 'rectangle' : (item.pictures.length > 1 ? 600 : 1000) : 90"/>
                </div>

                <!-- Visuels secondaires -->

                <div class="col_12 col_md_6 col_right">

                    <div class="row h_full">

                        @if(item.pictures.length > 1) {

                            @for(picture of item.pictures.slice(1, countDefaultDisplayedPictures); track picture) {

                                <div class="col_6">

                                    <img [src]="item | offerCreatorPictureSource: picture : 'rectangle' : 300 : 90"/>

                                    @if($last && item.pictures.length <= countDefaultDisplayedPictures) {

                                        <div (click)="openPictureGalleryDialog()" class="see_more">
                                            <span>{{ 'offer.picture.open.value' | translate }}</span>
                                        </div>
                                    }

                                    @if($last && item.pictures.length > countDefaultDisplayedPictures) {

                                        <div (click)="openPictureGalleryDialog()" class="see_more">
                                            <span>{{ 'offer.picture.more.question.value' | translate }}</span>
                                        </div>
                                    }

                                </div>
                            }
                        }

                    </div>

                </div>

            </div>
        }

        <!-- Nombre d'offres -->

        @if((isMine && item.details.totalMarketplaceOffers > 0) || (!isMine && userService.hasOneOfThisRoles(currentUser, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']))) {

            <div class="ligne_form infos">

                <div class="row marges">

                    <div class="col_12 col_lg">

                        <!-- Nombre d'offres dans la marketplace -->

                        <div class="ck-content">
                            <p class="titre_h4">
                                @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])) {
                                    {{ item.details.totalMarketplaceOffers | translationFromQuantity:'offer.inMarketplace.total.empty.value' : 'offer.inMarketplace.total.singular.value' : 'offer.inMarketplace.total.plural.value' }}
                                }
                                @if(isMine || userService.hasOneOfThisRoles(currentUser, ['ROLE_OFFER_DISTRIBUTOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL'])) {
                                    {{ item.details.totalMarketplaceOffers | translationFromQuantity:'offer.inMarketplace.self.total.empty.value' : 'offer.inMarketplace.self.total.singular.value' : 'offer.inMarketplace.self.total.plural.value' }}
                                }
                            </p>
                        </div>

                        <br>

                        <div class="flags row marges">
                            @for(offerCountTranslation of marketplaceOfferCountTranslations; track offerCountTranslation) {
                                <div class="col_6 col_md_4 col_lg_3 flag_item">
                                    <div class="flag flag-{{ offerCountTranslation.locale }}"></div>
                                    <div class="count">
                                        @if(!isMine) {
                                            <a (click)="redirectToMarketplaceByLocale(offerCountTranslation.locale)">
                                                {{ offerCountTranslation.marketplace | translationFromQuantity:'offer.total.empty.value':'offer.total.singular.value':'offer.total.plural.value' }}
                                            </a>
                                        } @else {
                                            {{ offerCountTranslation.marketplace | translationFromQuantity:'offer.total.empty.value':'offer.total.singular.value':'offer.total.plural.value' }}
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {

                        <div class="col_12 col_lg">

                            <!-- Nombre d'offres dans le catalogue -->

                            <div class="ck-content">
                                <p class="titre_h4">
                                    {{ item.details.totalCatalogOffers | translationFromQuantity: 'offer.inCatalog.total.empty.value' : 'offer.inCatalog.total.singular.value' : 'offer.inCatalog.total.plural.value' }}
                                </p>
                            </div>

                            <br>

                            <div class="flags row marges">
                                @for(offerCountTranslation of catalogOfferCountTranslations; track offerCountTranslation) {
                                    <div class="col_6 col_md_4 col_lg_3 flag_item">
                                        <div class="flag flag-{{ offerCountTranslation.locale }}"></div>
                                        <div class="count">
                                            <a (click)="redirectToCatalogByLocale(offerCountTranslation.locale)">
                                                {{ offerCountTranslation.catalog | translationFromQuantity:'offer.total.empty.value':'offer.total.singular.value':'offer.total.plural.value' }}
                                            </a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                </div>

            </div>
        }

        <!-- Présentation -->

        @if(getTranslation(item.details.societyInformation.translations).presentation) {

            <div class="row ligne_form infos no_border no_padding">

                <div class="col_12">
                    <div [innerHTML]="getTranslation(item.details.societyInformation.translations).presentation|safeHtml" class="description_offer ck-content"></div>
                </div>
            </div>
        }

        <!-- Informations complémentaires -->

        <div class="row marges ligne_form">

            <div class="col_6 additional_informations">

                <div class="infos green">

                    <!-- Cibles clientèle -->

                    @if(item.details.customerTypologies.length > 0) {

                        <div class="txt_offer">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'customer.target.plural.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                @for(customerTypology of item.details.customerTypologies; track customerTypology) {
                                    <span>{{ getTranslation(customerTypology.translations).name }}</span><br/>
                                }
                            </p>

                        </div>
                    }

                    <!-- Destinations -->

                    @if(item.details.allRegions || (item.details.regions.length > 0)) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'destination.plural.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                @if(item.details.allRegions) {

                                    <span>{{ 'france.all.value' | translationForLocale: locale | async }}</span>

                                } @else {

                                    @for(region of getSortedAttributes(item.details.regions); track region) {

                                        <span style="font-weight: bold">{{ getTranslation(region.translations).label }} :</span><br/>

                                        <span class="detail_info">{{ parsedChildAttributesFromParent(region, item.details.administrativeAreas) }}</span>

                                        <br/>
                                    }
                                }
                            </p>

                        </div>
                    }

                    <!-- Types de séjours -->

                    @if(item.details.types.length > 0) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'stay.plural.type.plural.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                @for(type of getSortedAttributes(item.details.types); track type) {
                                    <span>{{ getTranslation(type.translations).label }}</span><br/>
                                }
                            </p>

                        </div>
                    }

                    <!-- Types d'offres -->

                    @if(offerTypes.length > 0) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'offer.plural.type.plural.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                @for(offerType of offerTypes; track offerType) {
                                    <span>{{ ('offer.type.' + offerType + '.value') | translationForLocale: locale | async }}</span><br/>
                                }
                            </p>

                        </div>
                    }

                </div>

            </div>

            <div class="col_6 additional_informations">

                <div class="infos green">

                    <!-- Immatriculation -->

                    @if(item.registration) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'immatriculation.value' | translate }} <span class="info">{{ 'immatriculation.info.value' | translate }}</span></p>
                            </div>
                            <br>
                            <p>
                                <span>{{ item.registration }}</span><br/>
                            </p>

                        </div>
                    }

                    <!-- Garantie financière -->

                    @if(item.financialGuarantee) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'offerCreator.society.financialGuarantee.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                <span>{{ item.financialGuarantee }}</span><br/>
                            </p>

                        </div>
                    }


                    <!-- Responsabilité civile profesionnnelle -->

                    @if(item.insurancePolicy) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'offerCreator.society.insurancePolicy.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                <span>{{ item.insurancePolicy }}</span><br/>
                            </p>

                        </div>
                    }

                    <!-- Langues parlées -->

                    @if((item.details.societyInformation.spokenLanguages.length > 0) || item.details.societyInformation.hasOtherSpokenLanguages) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'language.plural.spoken.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                @for(spokenLanguage of item.details.societyInformation.spokenLanguages; track spokenLanguage) {
                                    <span>{{ ('locale.' + spokenLanguage + '.value') | translationForLocale: locale | async }}</span><br/>
                                }

                                @if(item.details.societyInformation.hasOtherSpokenLanguages) {

                                    <br>

                                    <p style="font-weight: bold;">{{ 'other.pluralize.value' | translate }}</p>

                                    <span>{{ getTranslation(item.details.societyInformation.translations).spokenLanguages }}</span><br/>
                                }
                            </p>

                        </div>
                    }

                    <!-- Labellisé RSE -->

                    @if(item.details.societyInformation.hasRseLabel) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'rse.labelled.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                <span>{{ getTranslation(item.details.societyInformation.translations).rseLabel }}</span><br/>
                            </p>

                        </div>
                    }

                    <!-- Créateurs d’offres membre -->

                    @if(item.networkOfferCreators.length > 0) {

                        <div class="txt_offer little_border">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'offerCreator.member.plural.value' | translate }}</p>
                            </div>
                            <br>
                            <p>
                                @for(networkOfferCreator of item.networkOfferCreators; track networkOfferCreator) {
                                    <span>{{ networkOfferCreator.name }}</span><br/>
                                }
                            </p>

                        </div>
                    }

                </div>

                @if(item.details.termsAndConditions.length > 0) {

                    <br>

                    <div class="infos terms_and_conditions no_border no_padding">

                        <div class="txt_offer">

                            <div class="ck-content">
                                <p class="titre_h4">{{ 'termsAndConditions.value' | translate }}</p>
                            </div>
                            <br>
                            <div class="row">

                                <div class="col_4">

                                    @for(termsAndCondition of item.details.termsAndConditions; track termsAndCondition) {
                                        <p>
                                            <span style="font-weight: bold">{{ getTranslation(termsAndCondition.typology.translations).name }} : </span>
                                        </p>
                                    }

                                </div>
                                <div class="col_8">

                                    @for(termsAndCondition of item.details.termsAndConditions; track termsAndCondition) {
                                        <p>
                                            @for(termsAndConditionTranslation of termsAndCondition.translations; track termsAndConditionTranslation) {
                                                <span class="terms_and_conditions_locale_item" (click)="downloadTermsAndCondition(termsAndConditionTranslation)">
                                                    {{ termsAndConditionTranslation.locale|uppercase }}
                                                </span>
                                            }
                                        </p>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </div>

        @if(!isMine && userService.hasOneOfThisRoles(currentUser, ['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {

            <br>

            <div class="row marges ligne_form infos">

                <div class="col_12">

                    <!-- Commentaire -->

                    <div class="form-group">
                        <textarea placeholder=" " class="form-control" formControlName="comment" id="comment"></textarea>
                        <label for="comment">{{ 'offerCreator.comment.value' | translate }}</label>
                    </div>
                </div>

            </div>

            <div class="row marges ligne_form">

                <div class="col_12 x_start">

                    <!-- Enregistrer -->

                    <button class="btn_cta btn_little" type="submit">
                        {{ 'form.submit.action.value' | translate }}
                    </button>

                </div>

            </div>
        }

    </form>
</div>
